import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { ApsButtonGroup, ApsLanguageButton, ApsModalBody, ApsModalHeader } from 'UserExperience/portal-vnext';
import { useSession } from '../../../../../common/session/SessionContext';

const LanguageModal = ({ visible, onOk, onCancel }) => {

  const { t, i18n } = useTranslation();
  const { updateLanguage } = useSession();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    updateLanguage(language);
    onOk();
  };

  const changeToEnglish = () => {
    changeLanguage('en');
  };

  const changeToSpanish = () => {
    changeLanguage('es');
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      closable={false}
      footer = {null}
      centered={true}
      wrapClassName="modal-size-is-small"
      bodyStyle={{padding:0, fontSize: 16}}
      width={280}
      destroyOnClose={true}
    >
      {/* existing portal css needs some wrapper element so modal font, etc., will be applied */}
      <emulate-ng-include>
        <ApsModalHeader
          titleText={t('global.chooseLanguage')}
          titleAlign="center"
          titleSize="small"
        />
        <ApsModalBody hasPadding={true}>
          <ApsButtonGroup
            groupDirection="column"
            groupType="separate"
          >
            <ApsLanguageButton
              buttonLabel="English"
              buttonContent="english"
              onClick={changeToEnglish}
            />
            <ApsLanguageButton
              buttonLabel="en Español"
              buttonContent="spanish"
              onClick={changeToSpanish}
            />
          </ApsButtonGroup>
        </ApsModalBody>
      </emulate-ng-include>
    </Modal>
  );
};

export default LanguageModal;